import angular from "angular";

export default angular.module("app.events", []).constant("Events", {
  RELOAD_DASHBOARD: "dashboard:reload",
  RELOAD_DASHBOARD_LAZY: "dashboard:reloadLazy",
  PORTLET_SWAP: "dashboard:swap",
  PORTLET_CLOSE: "dashboard:closePortlet",
  PORTLET_ADD: "dashboard:addPortlet",
  NAV_TOGGLE_MENU: "dcPageContainer:toggleMenu",
  NAV_TOGGLE_SIDEBAR: "dcPageContainer:toggleSidebar",
  MESSAGES_RELOAD: "messages:reloadMessages",
  USER_CHANGED: "app.userChanged",
  RESIZE_CHART: "resizeMsg",
  STATISTICS_LOADED: "statistics:loaded",
  STATISTICS_DAS_LOADED: "statisticsDas:loaded",
  STATISTICS_CINV_LOADED: "statisticsCinv:loaded",
  RELOAD_COMPANY_TREE: "companyTree:reload",
  CHECK_MAINTENANCE: "ConfigService.checkMaintenance",
  MAINTENANCE_CHANGED: "MaintenanceService.maintenanceChanged",
  SHOW_GLOBAL_ERROR: "MaintenanceService.showGlobalError",
  SHOW_REQUEST_ERROR: "MaintenanceService.showRequestError",
  LOGOUT: "AuthenticationService.logout",
  RELOAD_MENU: "eaAddCardPage.addCard",
}).name;



// WEBPACK FOOTER //
// ./src/ui/app/services/Events.js